var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1323 -496)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    fill: "none",
    width: 18,
    height: 16,
    transform: "translate(1323 496)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1323.004 498)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    fill: "#9c9c9c",
    d: "M173.016,170.667a2.349,2.349,0,1,0,2.349,2.349A2.351,2.351,0,0,0,173.016,170.667Z",
    transform: "translate(-164.404 -167.144)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    fill: "#9c9c9c",
    d: "M8.612,74.667A9.259,9.259,0,0,0,0,80.539a9.252,9.252,0,0,0,17.224,0A9.256,9.256,0,0,0,8.612,74.667Zm0,9.787a3.915,3.915,0,1,1,3.915-3.915A3.916,3.916,0,0,1,8.612,84.454Z",
    transform: "translate(0 -74.667)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ae9bce479e644e4181fa34b783f54824.svg";
export { ForwardRef as ReactComponent };